/** Placeholder while the lazily-loaded workbench chunk and its adapter load. */
export function ModuleLoading() {
  return (
    <p className="p-6 text-content-secondary text-sm" role="status">
      Loading commission review…
    </p>
  );
}
